import { render, staticRenderFns } from "./list-zbr.vue?vue&type=template&id=6dc6e1e2&"
import script from "./list-zbr.vue?vue&type=script&lang=js&"
export * from "./list-zbr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports